import React, { Component } from 'react';
import { connect } from 'react-redux';
import { parse, parseExcel } from 'store/reducers/user';
import * as Page from 'HOC/Layout/PageContainer';
import { axiosCms } from 'Axios.js';
import WithError from 'HOC/Error/WithError';

import styles from './UsersPage.module.css';

import UsersTable from 'components/Users/UsersTable';
import { fetchUsers } from 'store/actions/index';

const { Container, Title } = Page;

class UsersPage extends Component {
  componentDidMount() {
    const { fetchUsers } = this.props;
    fetchUsers();
  }

  renderContainer = () => {
    const { parsedUsers, isLoading } = this.props;
    return (
      <Container type="2x3">
        <Title title="Users" />
        <div className={styles.Main}>
          <UsersTable
            users={parsedUsers}
            // unVerifyUser={unVerifyUser}
            isLoading={isLoading}
          />
        </div>
      </Container>
    );
  };

  render() {
    return this.renderContainer();
  }
}

const mapStateToProps = state => {
  const { users } = state.user;
  const parsedUsers = parse(users);
  const parseUsersToExcel = parseExcel(users);
  const isLoading = state.user.loading || state.auth.loading;
  return {
    parsedUsers,
    parseUsersToExcel,
    isLoading,
  };
};

const mapDispatchToProps = { fetchUsers };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithError(UsersPage, axiosCms));



// WEBPACK FOOTER //
// ./src/containers/Users/UsersPage.js